var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 9.00005C16.2 12.9765 12.9765 16.2 9.00005 16.2C5.0236 16.2 1.80005 12.9765 1.80005 9.00005C1.80005 5.0236 5.0236 1.80005 9.00005 1.80005C12.9765 1.80005 16.2 5.0236 16.2 9.00005ZM9.00006 6.30005C8.66807 6.30005 8.37689 6.47934 8.21991 6.7507C7.97103 7.18096 7.42047 7.32798 6.99022 7.07909C6.55996 6.83021 6.41294 6.27965 6.66182 5.8494C7.12731 5.04471 7.99955 4.50005 9.00006 4.50005C10.4912 4.50005 11.7001 5.70888 11.7001 7.20005C11.7001 8.37565 10.9487 9.37576 9.90006 9.74641V9.90005C9.90006 10.3971 9.49712 10.8 9.00006 10.8C8.50301 10.8 8.10006 10.3971 8.10006 9.90005V9.00005C8.10006 8.50299 8.50301 8.10005 9.00006 8.10005C9.49712 8.10005 9.90006 7.69711 9.90006 7.20005C9.90006 6.70299 9.49712 6.30005 9.00006 6.30005ZM9.00005 13.5C9.49711 13.5 9.90005 13.0971 9.90005 12.6C9.90005 12.103 9.49711 11.7 9.00005 11.7C8.50299 11.7 8.10005 12.103 8.10005 12.6C8.10005 13.0971 8.50299 13.5 9.00005 13.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.c00c246a4c3402b0b8102beb2f307502.svg";
export { ForwardRef as ReactComponent };